import { NumberFormat as _NumberFormat, isUnitSupported } from '@formatjs/intl-numberformat';

// TODO: Need to revisit all supported languages to include locale-data. Defaults to `en`.
// https://github.com/formatjs/formatjs/blob/%40formatjs/intl-numberformat%404.2.10/website/docs/polyfills/intl-numberformat.md
// eslint-disable-next-line no-underscore-dangle -- required by ponyfill
_NumberFormat.__addLocaleData(
  // eslint-disable-next-line @typescript-eslint/no-var-requires -- required by ponyfill
  require('@formatjs/intl-numberformat/dist/locale-data/en.json'),
);

// Fallback to native NumberFormat if `compact` notation is supported.
// https://github.com/tc39/proposal-unified-intl-numberformat
export const NumberFormat = (isUnitSupported('bit') ? Intl.NumberFormat : _NumberFormat) as typeof Intl.NumberFormat;
